import React, { FC, useState } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { Box, BoxProps, Button, Icon, Stack } from '@hover/blueprint';
import { iMenu, iX } from '@hover/icons';
import { useLockedBody } from '../../../utils/hooks';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import NavbarMobileItem from './NavbarMobileItem';

export interface NavbarMobileProps {
  links: INavbarItem[];
  isNavbarWhite: boolean;
  navbarColor: BoxProps['color'] | undefined;
  titleColor?: string;
  logo: JSX.Element;
}

const NavbarMobile: FC<NavbarMobileProps> = ({
  links,
  isNavbarWhite,
  navbarColor,
  titleColor,
  logo,
}) => {
  const [activeTabLabel, setActiveTabLabel] = useState<string | null>(null);

  const { isOpen, onToggle } = useDisclosure();
  const { setLocked } = useLockedBody();

  function handleActiveTab(label: string) {
    if (activeTabLabel === label) setActiveTabLabel(null);
    else setActiveTabLabel(label);
  }

  const toggleNavbar = () => {
    setLocked(!isOpen);
    onToggle();
  };

  const mobileNavColor = isOpen ? 'neutral.0' : navbarColor;
  const isWhiteBackground = isOpen || isNavbarWhite;

  return (
    <Box
      px={500}
      transition="background 0.3s ease"
      display="flex"
      flexDirection="column"
      width="100%"
      bg={mobileNavColor}
    >
      <Box
        display="flex"
        py="5"
        alignItems="center"
        height="64px"
        justifyContent="space-between"
      >
        {logo}
        <Button
          fill="minimal"
          label="Menu"
          shape="circle"
          size="large"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
        >
          <Icon
            size="default"
            color={
              !isWhiteBackground && !titleColor ? 'neutral.0' : 'primary.600'
            }
            icon={isOpen ? iX : iMenu}
          />
        </Button>
      </Box>
      {isOpen ? (
        <Box
          position="fixed"
          left={0}
          right={0}
          top={900}
          bottom={0}
          zIndex="10"
          overflowY="scroll"
          bg="neutral.0"
          display="flex"
          flexDir="column"
        >
          <Stack
            px={500}
            py={700}
            display={{ desktop: 'none', base: 'flex' }}
            w="100%"
          >
            {links.map(navItem => (
              <NavbarMobileItem
                {...navItem}
                key={navItem.label}
                isOpen={activeTabLabel === navItem.label}
                onToggle={() => {
                  if (navItem.children) handleActiveTab(navItem.label);
                }}
              />
            ))}
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
};

export default NavbarMobile;
